import type { ElementType } from 'react';
import { CdIndicatorDot } from '../../atoms/CdIndicatorDot';
import { CdLink } from '../../atoms/CdLink';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdFeedItem.module.scss';

export interface CdFeedItemProps {
  id: string;
  title: string;
  lines: string[];
  /** Relative time, e.g. "37 days ago". */
  timestamp: string;
  unread?: boolean;
  /** Highlighted (e.g. the newest item). */
  highlighted?: boolean;
  actionLabel?: string;
  href?: string;
  linkAs?: ElementType;
  className?: string;
}

/** Notification / activity entry (Figma Notifications panel card). */
export const CdFeedItem = ({
  id,
  title,
  lines,
  timestamp,
  unread = false,
  highlighted = false,
  actionLabel = 'View',
  href,
  linkAs,
  className,
}: CdFeedItemProps) => {
  return (
    <article
      className={cx(styles.item, highlighted && styles.highlighted, className)}
      aria-labelledby={`${id}-title`}
    >
      <header className={styles.header}>
        <CdHeading level={3} size="md" id={`${id}-title`}>
          {title}
        </CdHeading>
        {unread && <CdIndicatorDot label="Unread" />}
      </header>
      {lines.map((line) => (
        <CdText key={line}>{line}</CdText>
      ))}
      <footer className={styles.footer}>
        <CdText variant="small" tone="secondary">
          {timestamp}
        </CdText>
        {href && (
          <CdLink as={linkAs} href={href} withArrow size="sm">
            {actionLabel}
          </CdLink>
        )}
      </footer>
    </article>
  );
};
